import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'kn-br-message-dialog',
    templateUrl: './kn-br-message-dialog.component.html',
    styleUrls: ['./kn-br-message-dialog.component.scss'],
    imports: [TranslatePipe]
})
export class KnBrMessageDialogComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() innerHtml: string;
  constructor(private activeModal: NgbActiveModal) {}
  ngOnInit() {}

  public accept() {
    this.activeModal.close(true);
  }
  public dismiss() {
    this.activeModal.dismiss();
  }
}
